import * as React from 'react';

interface KeyboardShortcutTooltipProps {
    show: boolean;
    keyName: string;
}

export const KeyboardShortcutTooltip = ({ show, keyName }: KeyboardShortcutTooltipProps) => {
    if (show) {
        return (
            <span className="badge badge-info">
                <i className="fa fa-keyboard-o"></i>
                &nbsp;{keyName}
            </span>
        );
    } else {
        return null;
    }
}
